import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VParallax } from 'vuetify/lib/components/VParallax';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1000px",
      "persistent": ""
    },
    model: {
      value: _vm.twinDuplicatePrompt,
      callback: function ($$v) {
        _vm.twinDuplicatePrompt = $$v;
      },
      expression: "twinDuplicatePrompt"
    }
  }, [_vm.twinDuplicatePrompt ? _c('core-dtwin-duplicate-base', {
    attrs: {
      "orgTwin": _vm.dtwin,
      "orgTwinStates": _vm.twinDataStates
    },
    on: {
      "forceRefreshStates": _vm.forceRefreshStates,
      "close": _vm.duplicateCloseEvent
    }
  }) : _vm._e()], 1), _vm.twinSyncPrompt ? _c('core-dtwin-sync', {
    attrs: {
      "orgTwin": _vm.dtwin,
      "orgTwinStates": _vm.twinDataStates
    },
    on: {
      "close": _vm.syncCloseEvent
    }
  }) : _vm._e(), !_vm.loading ? _c('core-prompt', {
    attrs: {
      "title": this.$i18n_t('DigitalTwin.DigitalTwin.twinDeleteWarning'),
      "color": "error",
      "open": _vm.twinDeletePrompt,
      "buttons": [{
        text: this.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: this.$i18n_t('DigitalTwin.DigitalTwin.twinDelete'),
        dataCy: 'btn_twin_delete_confirm',
        color: 'red',
        emit: 'delete',
        disabled: _vm.hasDependentDevices || _vm.hasDependentTemplates
      }]
    },
    on: {
      "cancel": function ($event) {
        _vm.twinDeletePrompt = false;
      },
      "delete": function ($event) {
        _vm.twinDeletePrompt = false;
        _vm.$emit('delete-twin', _vm.dtwin);
      }
    }
  }, [_vm.hasDependentDevices ? [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinIsParentalObject')) + "\n      "), _c(VTreeview, {
    staticClass: "mt-2 infoTree",
    attrs: {
      "items": _vm.twinDependencies.virtualDevices,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [[_c('a', {
          attrs: {
            "href": `/#/virtual-devices/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(_vm.get(item, _vm.titleAttributePath)))])], _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 1808500525)
  })] : _vm._e(), _vm.hasDependentTemplates ? [_c('div', {
    class: {
      'mt-4': _vm.hasDependentDevices
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinIsParentalObjectTemplates')) + "\n      ")]), _c(VTreeview, {
    staticClass: "mt-2 infoTree",
    attrs: {
      "items": _vm.twinDependencies.deviceTemplates,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [_c('a', {
          attrs: {
            "href": `/#/device-templates/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.title))]), _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 2779955678)
  })] : _vm._e()], 2) : _vm._e(), _c(VCard, {
    staticClass: "mt-0 mb-8 dtwin-preview",
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_vm.showMap && !_vm.showSkeletonLoader ? _c(VContainer, {
    staticClass: "dtwin-map-frame fill-height pa-0"
  }, [_c('core-dtwin-map-header-map', {
    style: `width: 100%; ${!_vm.twinCanBeEdited(_vm.dtwin) ? 'opacity: 0.5' : ''}`,
    attrs: {
      "geoCoordinates": _vm.dtwinCoordinates,
      "overlayInfo": _vm.dtwinOverlayInfo,
      "dtwTitle": _vm.get(_vm.dtwin, _vm.titleAttributePath),
      "dtwData": _vm.dtwin.data,
      "mapInteractive": false,
      "preview": ""
    }
  })], 1) : _vm._e(), !_vm.showMap && _vm.headerBG || _vm.showSkeletonLoader ? _c('div', [_c(VParallax, {
    style: `width: 100%; ${!_vm.twinCanBeEdited(_vm.dtwin) ? 'opacity: 0.5' : ''}`,
    attrs: {
      "height": _vm.parallaxHeight,
      "src": _vm.headerBG
    }
  }, [_c('h3', {
    staticClass: "pl-3 pr-3 mt-6 dtwin-title-frame header-text text-truncate"
  }, [!_vm.showSkeletonLoader && _vm.dtwin.data.faIcon && _vm.dtwin.data.faIcon.trim().length > 0 ? _c(VIcon, {
    class: _vm.color + '--text headline-icon mr-1',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.dtwin.data.faIcon}`)
    }
  }) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.get(_vm.dtwin, _vm.titleAttributePath)) + "\n        ")], 1)])], 1) : _vm._e(), !_vm.showMap && !_vm.headerBG || _vm.showSkeletonLoader ? _c('div', [_c('div', {
    staticClass: "dtwin-detail-header",
    staticStyle: {
      "height": "143px"
    }
  }, [_c('h3', {
    staticClass: "pl-3 pr-3 mt-6 ml-4 header-text dtwin-title-frame text-truncate",
    attrs: {
      "data-cy": "selected_dtwin_title"
    }
  }, [_vm.get(_vm.dtwin, 'dtwin.data.faIcon', '').trim().length > 0 ? _c(VIcon, {
    class: _vm.color + '--text headline-icon mr-1',
    domProps: {
      "textContent": _vm._s(`fal fa-${_vm.dtwin.data.faIcon}`)
    }
  }) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.get(_vm.dtwin, _vm.titleAttributePath)) + "\n        ")], 1)])]) : _vm._e(), _c('div', {
    staticStyle: {
      "height": "0px",
      "overflow": "visible",
      "position": "relative",
      "top": "-60px",
      "right": "16px",
      "float": "right"
    }
  }, [_c('div', {
    staticClass: "actions-gradient px-2",
    staticStyle: {
      "height": "60px"
    }
  }, [!_vm.showSkeletonLoader ? [_vm.dtwin.properties && _vm.dtwin.properties.disabled ? _c('div', {
    staticClass: "mx-1 v-btn danger--text",
    staticStyle: {
      "float": "left",
      "margin": "10px auto",
      "line-height": "41px",
      "font-size": "12px",
      "font-weight": "600"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDisabled')) + "\n          ")]) : _vm._e(), _vm.hideItems.indexOf('share') < 0 && _vm.dtwin && _vm.dtwin.id ? _c('core-dtwin-share-button-dialogue', {
    attrs: {
      "twinId": _vm.dtwin.id
    }
  }) : _vm._e(), !_vm.mapmode ? [_c('core-button', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinLoadMap'),
      "color": _vm.color,
      "prepend-icon": "fa-map-marked-alt",
      "data-cy": "btn_twin_load_map"
    },
    on: {
      "click": function ($event) {
        _vm.pushToRouter('/digitaltwin-mgmt/map/twin/' + (_vm.dtwin ? _vm.dtwin.id : ''), _vm.dtwin);
      }
    }
  })] : _vm._e(), _vm.hideItems.indexOf('favorite') < 0 ? _c('core-favoriteselect', {
    staticClass: "mr-1 ml-0",
    attrs: {
      "objectId": _vm.dtwin.id,
      "type": "digitalTwin",
      "asRoundButton": ""
    }
  }) : _vm._e(), _c('core-button', {
    attrs: {
      "title": _vm.detailButtonTitle,
      "color": _vm.color,
      "prepend-icon": _vm.detailButtonIcon,
      "data-cy": "btn_twin_detail"
    },
    on: {
      "click": function ($event) {
        return _vm.changeTwin(_vm.dtwin);
      }
    }
  }), _vm.twinCanBeEdited(_vm.dtwin) && !_vm.mapmode ? [_vm.dtwin.parentId >= 1 || _vm.permissions['super.system.manage'] ? _c('core-button', {
    attrs: {
      "disabled": _vm.loading !== false,
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.duplicateDigitalTwin'),
      "prepend-icon": "fa-copy",
      "data-cy": "btn_twin_duplicate"
    },
    on: {
      "click": function ($event) {
        _vm.twinDuplicatePrompt = true;
      }
    }
  }) : _vm._e(), _c('core-button', {
    attrs: {
      "disabled": _vm.loading !== false,
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.syncDigitalTwin'),
      "prepend-icon": "fa-share-square",
      "data-cy": "btn_twin_sync"
    },
    on: {
      "click": function ($event) {
        _vm.twinSyncPrompt = true;
      }
    }
  })] : _vm._e(), _vm.twinCanBeDeleted() && !_vm.mapmode ? [_vm.hasTwinManageAllPermission && _vm.dtwin.parentId && (!_vm.dtwin.children || _vm.dtwin.children.length === 0) ? _c('core-button', {
    attrs: {
      "data-cy": "btn_twin_delete",
      "color": _vm.color,
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDelete'),
      "prepend-icon": "fa-trash-alt"
    },
    on: {
      "click": function ($event) {
        _vm.twinDeletePrompt = true;
        _vm.fetchTwinDependencies(_vm.dtwin);
      }
    }
  }) : _vm._e()] : _vm._e(), _vm.mapmode ? _c('core-button', {
    attrs: {
      "color": "danger",
      "title": _vm.$i18n_t('Common.cancel'),
      "prepend-icon": "fa-times",
      "data-cy": "btn_twin_cancel"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('cancel');
      }
    }
  }) : _vm._e()] : [_c(VSkeletonLoader, {
    attrs: {
      "type": "actions"
    }
  })]], 2)]), _c(VCardText, {
    staticStyle: {
      "overflow": "auto"
    }
  }, [!_vm.showSkeletonLoader && _vm.dtwin.data.description && _vm.dtwin.data.description.trim().length > 0 ? _c(VRow, [_c(VCol, {
    style: _vm.descriptionHeight,
    attrs: {
      "cols": "12"
    }
  }, [_c('markdown-it-vue-light', {
    attrs: {
      "content": _vm.dtwin.data.description || _vm.$i18n_t('Common.notAvailable')
    }
  })], 1)], 1) : _vm.showSkeletonLoader ? _c(VRow, [_c(VCol, [_c(VSkeletonLoader, {
    attrs: {
      "type": "paragraph"
    }
  })], 1)], 1) : _vm._e(), !_vm.showSkeletonLoader ? _c(VRow, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, _vm._l(_vm.dtwin.data.tags, function (item, i) {
    return _c(VChip, {
      key: i,
      staticClass: "ma-1"
    }, [_vm._v("\n            " + _vm._s(item) + "\n          ")]);
  }), 1)], 1) : _vm._e(), _vm.twinDataStates !== null ? _c('div', [_vm.isObjEmpty(_vm.twinDataStates) && (_vm.showSkeletonLoader || _vm.loading) ? _c('div', {
    staticClass: "d-flex justify-center align-center"
  }, [_c(VProgressCircular, {
    attrs: {
      "size": 50,
      "width": 2,
      "color": _vm.color,
      "indeterminate": ""
    }
  })], 1) : _vm.dtwin.dashboardId ? _c(VCard, {
    style: {
      backgroundColor: _vm.UiTheme ? '#2d2d2d' : '#E5E5E5'
    }
  }, [_c('dashboard', {
    attrs: {
      "dashboardId": _vm.dtwin.dashboardId,
      "widget-min-size": 2
    }
  })], 1) : _c('core-dtwin-state-preview-db-tiles', {
    attrs: {
      "twinDataStates": _vm.twinDataStates,
      "updatedStates": _vm.updatedStates,
      "loading": _vm.showSkeletonLoader || _vm.loading !== false,
      "overflow": _vm.mapmode
    },
    on: {
      "didUpdateStates": _vm.didUpdateStates
    }
  })], 1) : _vm._e(), _c(VDivider, {
    staticClass: "mt-2"
  }), _c(VRow, [_vm.hasTwinManageAllPermission ? _c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.showDetilsIdTrans) + ": " + _vm._s(_vm.dtwin.id) + ", " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.scope')) + "-" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(_vm.dtwin.scopeId) + ",\n          "), !_vm.showSkeletonLoader ? [_vm._v("\n            " + _vm._s(_vm.$i18n_t('Common.tenant')) + ": " + _vm._s(_vm.dtwin.tenantName || _vm.dtwin.tenantId) + "\n            "), _vm.dtwin.tenantName ? [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(_vm.dtwin.tenantId) + ")")] : _vm._e()] : _vm._e()], 2) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };